import React from 'react';

const ChartSearchIcon: React.FC = () => (
  <svg width="74" height="75" viewBox="0 0 74 75" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M64.7906 65.0162L58.141 58.3665L51.4913 51.7169M58.9435 57.564L65.5932 64.2137L63.9881 65.8188L57.3384 59.1691M58.676 34.443C58.676 47.9511 47.7255 58.9016 34.2174 58.9016C20.7093 58.9016 9.75879 47.9511 9.75879 34.443C9.75879 20.9349 20.7093 9.98438 34.2174 9.98438C47.7255 9.98438 58.676 20.9349 58.676 34.443Z"
      stroke="#475467"
      strokeWidth="4.58599"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.5 21.459C25.9832 21.459 26.375 21.8507 26.375 22.334L26.375 45.6673C26.375 46.1506 25.9832 46.5423 25.5 46.5423C25.0168 46.5423 24.625 46.1506 24.625 45.6673L24.625 22.334C24.625 21.8507 25.0168 21.459 25.5 21.459Z"
      fill="#00A389"
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.2083 41.584C39.2083 40.1342 38.033 38.959 36.5833 38.959H24.6249V45.3757H36.5833C38.033 45.3757 39.2083 44.2004 39.2083 42.7507V41.584Z"
      fill="#00A389"
    />
    <path
      opacity="0.4"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.375 33.416C47.375 31.9663 46.1997 30.791 44.75 30.791L24.625 30.791V37.2077L44.75 37.2077C46.1997 37.2077 47.375 36.0324 47.375 34.5827V33.416Z"
      fill="#00A389"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.875 25.25C36.875 23.8003 35.6997 22.625 34.25 22.625L24.625 22.625V29.0417L34.25 29.0417C35.6997 29.0417 36.875 27.8664 36.875 26.4167V25.25Z"
      fill="#00A389"
    />
  </svg>
);

export default ChartSearchIcon;
